import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// Show/Hide password field with eye toggle + Caps Lock indicator.
// Never reveals stored passwords — only what the user is currently typing.
export function PasswordInput({ value, onChange, className = "", showCaps = true, ...props }) {
  const [show, setShow] = useState(false);
  const [caps, setCaps] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        onKeyUp={showCaps ? (e) => { try { setCaps(e.getModifierState && e.getModifierState("CapsLock")); } catch (_) { /* ignore */ } } : undefined}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "pw-toggle"}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Sembunyikan password" : "Tampilkan password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 transition-colors hover:text-gray-600"
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
      {showCaps && caps && <span className="absolute right-9 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-amber-600">Caps Lock</span>}
    </div>
  );
}
